<template>
    <!-- 应用成效 -->
    <div class="application_results" ref="results">
        <div ref="bganimation" :style="{background:'url('+applicationResults.bg+') no-repeat'}">
            <div class="containers">
                <h1 class="partH1" ref="HeaderTitle">应用成效</h1>
                <ul class="application_results_ul feature_ul_bg" ref="ul">
                    <li class="application_results_li"  v-for="(item,index) in applicationResults.dataLi.part1" :key="index">
                        <img :src="item.img">
                        <p>{{item.title}}</p>
                    </li>
                </ul>
                <ul ref="ul2" class="application_results_ul feature_ul_bg">
                    <li class="application_results_li" v-for="(item,index) in applicationResults.dataLi.part2" :key="index">
                        <img :src="item.img">
                        <p>{{item.title}}</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import animationUtils from "@/utils/animationUtils.js";
    import animationIndex from "@/utils/animationIndex.js";

    export default {
        props: {
            applicationResults: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                // liDom: [],
            }
        },
        mounted() {
            // this.applicationResults.dataLi.forEach((item, index) => { //获取需要给加动画的各个li的ref节点
            //     this.liDom.push(this.$refs[`li${index}`][0].classList);
            // })

            window.addEventListener("scroll", this.menu);
        },
        beforeDestroy() { //在加载时添加了scroll监听，如果不销毁，到下一个页面时，没有主动销毁，会报错'offsetTop' of undefined。因此，需要在页面跳转前销毁此监听
            window.removeEventListener("scroll", this.menu)
        },
        methods: {
            menu() {
                let ulOffsetTop; //获取当前元素距离文档顶部的高度
                let ul2OffsetTop; //获取当前元素距离文档顶部的高度
                let HeaderTitleOffsetTop
                // 判断是否为Safari浏览器
                if(/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)){
                    ulOffsetTop = (this.$refs.ul.offsetTop - this.$refs.results.offsetTop) +this.$refs.results.offsetTop; //获取当前元素距离文档顶部的高度

                    ul2OffsetTop = (this.$refs.ul2.offsetTop - this.$refs.results.offsetTop) +this.$refs.results.offsetTop; //获取当前元素距离文档顶部的高度
                    HeaderTitleOffsetTop = this.$refs.HeaderTitle.offsetTop ; //获取当前元素距离文档顶部的
                    // console.log(ulOffsetTop)


                } else {
                    // ulOffsetTop = this.$refs.ul.offsetTop
                    ulOffsetTop = this.$refs.ul.offsetTop+this.$refs.results.offsetTop; //获取当前元素距离文档顶部的高度
                    // ul2OffsetTop = this.$refs.ul2.offsetTop
                    ul2OffsetTop = this.$refs.ul2.offsetTop+this.$refs.results.offsetTop; //获取当前元素距离文档顶部的高度

                    HeaderTitleOffsetTop =this.$refs.results.offsetTop + this.$refs.HeaderTitle.offsetTop  //获取当前元素距离文档顶部的
                }

                let ulList = this.$refs.ul.classList; //获取当前元素距离文档顶部的高度
                let ul2List = this.$refs.ul2.classList; //获取当前元素距离文档顶部的高度

                // let ulOffsetTop = this.$refs.ul.offsetTop; //获取当前元素距离文档顶部的高度
                // let ulOffsetTop = 250+this.$refs.results.offsetTop; //获取当前元素距离文档顶部的高度
                /**
                 * animationIndex第一个参数为需要动画的dom元素的高度，
                 * 第二个参数为li的每个单元的dom样式类数组
                 * 第三个参数为动画样式类名称
                 * 第四个参数为每个li动画执行间隔时间
                 * */
                // animationIndex.animationIndex(ulOffsetTop, this.liDom, "fade--in", 600);

                /**
                 * animations方法的第一个参数是需要动画的dom元素的高度，
                 * 第二个参数是需要加动画的dom元素的样式列表数组，
                 * 第三参数是动画类型（样式类名）activeTitle：文字动画，activeShade图片出现前的遮罩动画，activeTitle图片动画
                 */
                //标题动画
                // let HeaderTitleOffsetTop = this.$refs.HeaderTitle.offsetTop + this.$refs.results.offsetTop; //获取当前元素距离文档顶部的高度
                // console.log(HeaderTitleOffsetTop);
                // console.log(this.$refs.HeaderTitle.offsetTop);
                
                // let HeaderTitleOffsetTop = this.$refs.HeaderTitle.offsetTop; //获取当前元素距离文档顶部的高度
                // let HeaderTitleOffsetTop = 200 + this.$refs.results.offsetTop; //获取当前元素距离文档顶部的高度

                animationUtils.animations(ulOffsetTop, ulList, "activeTitle");
                animationUtils.animations(ul2OffsetTop, ul2List, "activeTitle");

            
                let HeaderTitle = this.$refs.HeaderTitle.classList;
                animationUtils.animations(HeaderTitleOffsetTop, HeaderTitle, "activeTitle");

                //   背景动画
                let bganimationOffsetTop = this.$refs.bganimation.offsetTop; //第四部分距离文档顶部的高度
                let bganimation = this.$refs.bganimation.classList; //第四部分距离文档顶部的高度
                animationUtils.animations(
                    bganimationOffsetTop,
                    bganimation,
                    "activeSecBg"
                );
            }
        },
    };
</script>

<style scoped>
    @media screen and (max-width: 1067px) {
        .system_features_li img {
            width: 260px;
            height: auto;
        }
    }

    @media screen and (min-width: 1067px) {
        .system_features_li img {
            width: 23.95833vw;
            height: auto;
        }
    }

</style>